<rask-page pageTitle="{{texts.header}}" [actionShow]="true" [actionFn]="popPage" actionTitle="{{texts.laggTill}}">
  <rask-container-block>
    <a routerLink="/components">Tillbaka till komponenter</a>
    <rask-tabs layout="header" [size]="5">
      <rask-tab [label]="texts.tab1label">
        <form id="exampleForm" [formGroup]="form" (ngSubmit)="save()">
          <rask-input class="col-3" [raskRule]="validationContext.current.fornamn" [label]="texts.namn"
            formControlName="name" placeholder="Namn"
          [infoText]="texts.namnInfo"></rask-input>
          <rask-input class="col-6" [raskRule]="validationContext.current.efternamn" [label]="texts.efternamn"
          formControlName="surname"></rask-input>
          <rask-input-number [required]="true" class="col-3" [label]="texts.alder" formControlName="age">
          </rask-input-number>
          <rask-input class="col-6" [label]="texts.langText" formControlName="longText"></rask-input>
          <rask-input class="col-6" formControlName="disabledText"></rask-input>
          <rask-input class="col-12" [label]="texts.extraLangText" formControlName="extraLongText">
          </rask-input>
          <rask-input [label]="texts.otherText" formControlName="otherText" class="col-6"></rask-input>
          <rask-checkbox class="col-3" [text]="texts.accept" label="Med label" formControlName="accept">
          </rask-checkbox>
          <rask-checkbox class="col-3" [text]="texts.accept"></rask-checkbox>
          <rask-selector class="col-6" label="Min test" formControlName="selection" [values]="selectorValues"
            [showHeader]="true">
            <ng-container header><span>Sveaskog AB&nbsp;<a href="http://www.sveaskog.se" target="_blank"><i
            class="far fa-external-link" aria-hidden="true"></i></a></span></ng-container>
          </rask-selector>
          <rask-selector class="col-6" [label]="texts.selectorGroupTest" formControlName="selectionGrouped"
            [groupBy]="selectorGroupBy" [viewFormatter]="selectorFormatter"
            [formatter]="selectorOutputFormatter" [values]="groupedSelectorValues">
          </rask-selector>
          <rask-datepicker [label]="texts.datePicker" formControlName="datePicker" class="col-3">
          </rask-datepicker>
          <rask-datepicker [label]="texts.slutmanadPicker" [minDate]="model.datePicker"
            formControlName="monthPicker" (change)="pop($event)" [onlyMonths]="true" class="col-3">
          </rask-datepicker>
          <rask-datepicker-interval [labelStartDate]="texts.start" [labelEndDate]="texts.slut"
            (startDate)="pop($event)" (endDate)="pop($event)" [onlyMonths]="true">
          </rask-datepicker-interval>
          <rask-tree-selector class="col-6" [label]="texts.treeSelector" [items]="treeSelectorValues"
            formControlName="treeSelector" [showHeader]="true">
            <ng-container header><span>Sveaskog AB&nbsp;<a href="http://www.sveaskog.se" target="_blank"><i
            class="far fa-external-link" aria-hidden="true"></i></a></span></ng-container>
          </rask-tree-selector>
          <rask-tree-selector class="col-6" placeholder="Trädselector enkel"
            [label]="texts.treeSelectorSingle" [items]="treeSelectorSingleValues"
          formControlName="treeSelectorSingle"></rask-tree-selector>
          <rask-multi-selector class="col-6" [label]="texts.multiSelector" [items]="multiSelectorValues"
            bindLabel="text" bindValue="value" (change)="pop($event)" [selected]="model.multiSelector"
            formControlName="multiSelector">
          </rask-multi-selector>
          <rask-multi-selector class="col-6" [label]="texts.multiSelectorGroupBy"
            [items]="multiSelectorValues" bindLabel="text" bindValue="value" groupBy="groupName"
            (change)="pop($event)" [selected]="model.multiSelector" formControlName="multiSelector"
            [searchFn]="customSearchFn">
          </rask-multi-selector>
          <rask-tag class="col-6" [label]="texts.tag" [selected]="tagValues" formControlName="tag"
            (change)="pop($event)">
          </rask-tag>
          <rask-radiobutton-group class="col-6" formControlName="radioButtons" label="Radiobuttons"
            [buttons]="[{key:'111',value:'Ja'},{key:'222',value:'Nej'},{key:'333',value:'Kanske'}]">
          </rask-radiobutton-group>
          <rask-textmultiline
            label="Readonly - en rad"
            value="Test">
          </rask-textmultiline>
          <rask-textmultiline
            label="Readonly - två rader"
            [values]="['Hej','då']">
          </rask-textmultiline>
          <rask-textarea class="col-12" label="test" [maxlength]="20" [rows]="3" formControlName="textArea">
          </rask-textarea>
          <rask-slider class="col-6" formControlName="opacity" [(ngModel)]="model.opacity" [min]="0" [max]="1"
            [step]="0.01" (change)="pop($event)" [useLabels]="true"
            [viewFormatter]="sliderOpacityValueFormatter">
          </rask-slider>
        </form>
      </rask-tab>
      <rask-tab [label]="texts.tab2label">
        <rask-table [data]="tableData" class="mt-1"></rask-table>
        <rask-table [data]="tableData" [editable]="true"></rask-table>
        <rask-table [data]="tableData" [columns]="columns"></rask-table>

        <rask-cards>
          <rask-card label="Rubrik H4" href="http://www.sveaskog.se" [size]="4" intent="delete">
            <ng-container>
              <rask-input class="col-2" label="År" value="1982" [readonly]="true"></rask-input>
              <rask-input class="col-2" label="Ort" value="Piteå" [readonly]="true"></rask-input>
              <rask-tree-selector class="col-4" [label]="texts.treeSelector" [items]="treeSelectorValues" [showHeader]="true">
                <ng-container header><span>Sveaskog AB&nbsp;<a href="http://www.sveaskog.se" target="_blank"><i
                class="far fa-external-link" aria-hidden="true"></i></a></span></ng-container>
              </rask-tree-selector>
              <rask-radiobutton-group class="col-4" label="Aktiv"
                [buttons]="[{key:'111',value:'Ja'},{key:'222',value:'Nej'}]">
              </rask-radiobutton-group>
            </ng-container>
          </rask-card>
          <rask-card label="Rubrik H3" [size]="3" intent="save">
            <ng-container>
              <rask-span class="col-12">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                and scrambled it to make a type specimen book.
              </rask-span>
            </ng-container>
          </rask-card>
          <rask-card label="Rubrik H2" [size]="2" intent="edit">
            <ng-container>
              <rask-span class="col-12">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                and scrambled it to make a type specimen book.
              </rask-span>
            </ng-container>
          </rask-card>
        </rask-cards>
        <rask-toggle-panel label="En Toggle Panel" [defaultExpanded]="true">
          <ng-container header>
            <rask-checkbox class="col-3 low" [text]="texts.accept" [(ngModel)]="model.accept">
            </rask-checkbox>
          </ng-container>
          <ng-container>
            <rask-slider class="col-12" [(ngModel)]="model.opacity" [min]="0" [max]="1" [step]="0.01" [useLabels]="true"
              [viewFormatter]="sliderOpacityValueFormatter">
            </rask-slider>
            <div [ngStyle]="{'opacity': model.opacity}">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
              industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
              and scrambled it to make a type specimen book. It has survived not only five centuries, but also the
              leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s
              with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop
              publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            </div>
          </ng-container>
        </rask-toggle-panel>
      </rask-tab>
      <rask-tab label="Övrigt" icon="fa-regular fa-square-ellipsis">
        <div class="pb-4">
          <rask-input class="col-3" label="Lorem" placeholder="Lorem"></rask-input>
          <rask-input class="col-6" label="Ipsum" placeholder="Ipsum"></rask-input>
        </div>
        <rask-tabs layout="parent" [closable]="true" closeIcon="fal fa-times">
          <rask-tab label="Information">
            <rask-input class="col-3" label="Förnamn" placeholder="Namn"></rask-input>
            <rask-input class="col-6" label="Efternamn" placeholder="Efternamn"></rask-input>
            <rask-input class="col-3" label="Postadress" placeholder="Postadress"></rask-input>
            <rask-input class="col-3" label="Postort" placeholder="Postort"></rask-input>
            <rask-input class="col-3" label="Postkod" placeholder="Postkod"></rask-input>
          </rask-tab>
          <rask-tab label="Karta" icon="fa-solid fa-map">
            <rask-map>
              <rask-map-layers></rask-map-layers>
            </rask-map>
          </rask-tab>
          <rask-tab label="Övrigt">
            <div class="col-12">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
              industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
              and scrambled it to make a type specimen book.
            </div>
          </rask-tab>
          <rask-tab label="Länk">
            <rask-header size="4" noPadding>Komponentsida</rask-header>
            <div>
              <p>
                Komponentsidan listar alla komponenter som används i Rask
              </p>
              <a href="/core/components">Gå till Komponentsida</a>
            </div>
            <rask-tabs layout="child" [closable]="true" closeIcon="fal fa-times">
              <rask-tab label="Child1">
                <p>
                  Flikförklaring<br/>
                  Översta rask-tabs har layout="header" och size="5" (Size 5 måste man sätta explicit)<br/>
                  Mellersta rask-tabs har layout="parent" och defaultsize (implicit 4)<br/>
                  Nedersta (denna) rask-tabs har layout="child" och defaultsize (implicit 4)
                </p>
              </rask-tab>
              <rask-tab label="Child2"></rask-tab>
              <rask-tab label="Child3"></rask-tab>
            </rask-tabs>
          </rask-tab>
        </rask-tabs>
      </rask-tab>
    </rask-tabs>
    <ng-container footer>
      <rask-submit-button color="primary" [disabled]="!canSave()" form="exampleForm" icon="far fa-save">
        {{texts.spara}}
      </rask-submit-button>
      <rask-button color="tertiary" (click)="reset()">{{texts.avbryt}}</rask-button>
    </ng-container>
  </rask-container-block>

  @if (showResults) {
    <rask-container-block>
      <rask-command-viewer [commands]="result"></rask-command-viewer>
      <ng-container footer>
        <rask-button color="primary" (click)="closeResults()">{{texts.stang}}</rask-button>
      </ng-container>
    </rask-container-block>
  }
</rask-page>